import {
    Box,
    Skeleton,
    Step,
    StepConnector,
    stepConnectorClasses,
    StepLabel,
    Stepper,
    styled
} from "@mui/material";

export const BootstrapStepConnector = styled(StepConnector)(({ theme }) => ({
    [`& .${stepConnectorClasses.line}`]: {
        flexDirection: "column",
        height: 5,
        borderLeftWidth: "1px",
        borderLeftColor: `${theme.palette.text.secondary}26`,
        borderLeftStyle: "solid"
    },
}));

export default function StepperLoading({ stepCount }: { stepCount: number }): JSX.Element {
    return (
        <Stepper
            activeStep={-1}
            orientation="vertical"
            connector={<BootstrapStepConnector />}
            sx={{
                "&.MuiStepper-vertical": {
                    ".MuiStepButton-vertical": {
                        ".MuiStepLabel-vertical": {
                            paddingTop: "0px",
                            paddingBottom: "0px"
                        }
                    }
                }
            }}
        >
            {Array.from({ length: stepCount }).map((_, index) => (
                <Step key={index}>
                    <StepLabel
                        sx={{ py: 0 }}
                        icon={
                            <Skeleton
                                variant="circular"
                                width={24}
                                height={24}
                            />
                        }
                    >
                        <Box sx={{ py: "4px" }}>
                            <Skeleton
                                variant="text"
                                width="70%"
                                height={20}
                            />
                        </Box>
                    </StepLabel>
                </Step>
            ))}
        </Stepper>
    )
}